import React from 'react';
import { CModal, ModalOverlay } from '@televet/kibble-ui/build/chakra';
import { ChannelFilterSelectionFragment } from 'shared/types/graphql';
import { IChannelListFilterSelection } from 'pages/Conversations/interfaces/IChannelListFilterSelection';
import SaveChannelListFilterModalContent from './SaveChannelListFilterModalContent';

interface ISaveChannelListFilterModal {
  isOpen: boolean;
  currentChannelFilterSelection: IChannelListFilterSelection;
  onSuccess: (channelFilterSelection: ChannelFilterSelectionFragment) => void;
  onCancel: () => void;
}

const SaveChannelListFilterModal = ({
  isOpen,
  currentChannelFilterSelection,
  onSuccess,
  onCancel,
}: ISaveChannelListFilterModal): JSX.Element => {
  return (
    <CModal isOpen={isOpen} isCentered size="sm" onClose={onCancel}>
      <ModalOverlay />
      <SaveChannelListFilterModalContent
        currentChannelFilterSelection={currentChannelFilterSelection}
        onSuccess={onSuccess}
        onCancel={onCancel}
      />
    </CModal>
  );
};

export default SaveChannelListFilterModal;
